import Api from '@/api';

const COMPANY_SETTINGS_GROUP = 'SCHEDULE_NOW';
const SETTINGS_SCHEDULING_KEY = 'scheduling';
const SETTINGS_SCHEDULING_REDIRECT_VALUE = 'request';

/**
 * Redirect to Classic if Company Scheduling setting dictates
 * @param {array} settings of CompanySettings from API
 * @param {string} companyLegacyId Legacy ID
 */
const redirectToClassicScheduling = (settings, companyLegacyId) => {
  const schedulingSetting = settings.find(setting => setting.type === SETTINGS_SCHEDULING_KEY);
  if (schedulingSetting && schedulingSetting.value === SETTINGS_SCHEDULING_REDIRECT_VALUE) {
    window.location.replace(`${process.env.VUE_APP_HG_CLASSIC_URL}appointment/schedule.htmls?companyId=${companyLegacyId}`);
  }
};

/**
 * Perform initial hydration for application-critical Company details
 *
 * @param context
 * @param {number|string} companyId
 * @returns {Promise}
 */
const initialHydration = (context, companyId) => new Promise((resolve, reject) => {
  context.dispatch('loadCompany', companyId)
    .then(res => context.dispatch('loadSettings', res.companyId))
    .then(() => resolve())
    .catch(err => reject(err));
});

const loadCompany = (context, companyId) => new Promise((resolve, reject) => {
  Api.companyService.getCompany(companyId)
    .then(response => {
      context.commit('setCompany', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setCompany', {});
      reject(error);
    });
});

const loadSettings = (context, companyId) => {
  context.commit('setSettingsLoading', true);

  return new Promise(async (resolve, reject) => {
    try {
      const settingsResponse = await Api.companyService
        .getCompanySettingsGroup(companyId, COMPANY_SETTINGS_GROUP);

      const settingsValue = (settingsResponse.data && settingsResponse.data.settings)
        ? settingsResponse.data.settings
        : [];
      const isActiveValue = (settingsResponse.data && settingsResponse.data.companyActive)
        ? settingsResponse.data.companyActive
        : false;

      redirectToClassicScheduling(
        settingsValue,
        context.state.company.id,
      );

      context.commit('setSettings', settingsValue);
      context.commit('setIsActive', isActiveValue);
      resolve(settingsValue);
    } catch (err) {
      context.commit('setSettingsError', err);
      reject(err);
    }

    context.commit('setSettingsLoading', false);
  });
};

export default {
  initialHydration,
  loadCompany,
  loadSettings,
};
